module.exports = __webpack_public_path__ + "static/media/tinkoff.25590724.png";